import { createAsyncThunk } from '@reduxjs/toolkit';
import getCredentials from '../../../../utils/getCredentials';
import setUpdateFiling from 'scenes/Filings/store/services/setUpdateFiling.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

/**
 * Save the filing being edited. `expectedUpdatedAt` is the version it was edited from; a
 * refused save (409) rejects with `{ code }` - FILING_SENT (sent meanwhile) or FILING_CHANGED
 * (written by someone else since) - so the editor can say which.
 */
export const updateFiling = createAsyncThunk(
  'filings/updateFiling',
  async ({ filing, expectedUpdatedAt }, { getState, rejectWithValue }) => {
    const { accessKeyId, secretAccessKey, sessionToken } =
      await getCredentials();

    const state = getState();

    const projectId = selectSelectedProjectId(state);

    const params = {
      accessKeyId,
      secretAccessKey,
      sessionToken,
    };

    let response;
    try {
      response = await setUpdateFiling(filing, projectId, params, expectedUpdatedAt);
    } catch (error) {
      if (error?.response?.status === 409) {
        return rejectWithValue({ code: error.response.data?.code });
      }
      throw error;
    }
    // The backend attaches appliedBidCorrections when a contract row's
    // business id was corrected; strip it so it never enters the filings
    // store (and can't round-trip into a later save).
    const { appliedBidCorrections = [], ...updatedFiling } = response || {};
    return { updatedFiling, appliedBidCorrections };
  }
);
